module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_9016.635dae1d.png";